module.exports = __webpack_public_path__ + "assets/img/3dgali.c8fd53d4.svg";